import type { ParsedListingFilters } from '../types';

const preferIdentityValues = (identityValues: string[], passThroughValues: string[]): string[] =>
  identityValues.length > 0 ? identityValues : passThroughValues;

/**
 * listingGetUrl is the permalink identity only (e.g. fandom=… on a fandom page).
 * Pass-through filters live on the address-bar query (?tags=5, ?ratings=0).
 * Prefer identity values when present, otherwise keep pass-through selections.
 */
export const mergeListingFilters = (
  identityFilters: ParsedListingFilters,
  passThroughFilters: ParsedListingFilters,
): ParsedListingFilters => ({
  fandoms: preferIdentityValues(identityFilters.fandoms, passThroughFilters.fandoms),
  tags: preferIdentityValues(identityFilters.tags, passThroughFilters.tags),
  universes: preferIdentityValues(identityFilters.universes, passThroughFilters.universes),
  statuses: preferIdentityValues(identityFilters.statuses, passThroughFilters.statuses),
  ratings: preferIdentityValues(identityFilters.ratings, passThroughFilters.ratings),
  characters: preferIdentityValues(identityFilters.characters, passThroughFilters.characters),
  pairingCharacters: preferIdentityValues(
    identityFilters.pairingCharacters,
    passThroughFilters.pairingCharacters,
  ),
});
